import { Controller } from "@hotwired/stimulus";
import $ from "jquery";

export default class extends Controller {
  static values = {
    modalClick: String,
  };

  connect() {
    if ($(".js-header-menu.is-open").length) {
      this.htmlFix();
    }
  }

  disconnect() {
    this.#closeImmediately();
  }

  //リサイズ時の処理
  layout() {
    if ($(window).width() >= 768) {
      $(".js-header-menu").each(function () {
        if ($(this).hasClass("is-open")) {
          $(this).show();
        }
      });

      //キー移動制御を非活性化
      $(".js-header-menu").off("keydown");
      this.modalClickValues = null;
    }
  }

  //トリガーでメニュー開く
  menuopen(e) {
    var trigger = $(e.currentTarget),
      target = trigger.attr("data-target"),
      targetMenu = $(target);

    if (trigger.hasClass("is-open")) {
      this.menuclose();
      this.htmlScroll();
      this.overlayOff();
    } else {
      if ($(window).width() >= 768) {
        this.menuClose();
        this.htmlScroll();
      }
      this.menuOpen(trigger, targetMenu);
      this.htmlFix();
    }
    document.activeElement.blur();
  }

  //バツボタンで閉じる
  menuclose() {
    this.menuClose();
    this.overlayOff();
    this.htmlScroll();
    document.activeElement.blur();
  }

  //オーバーレイクリックで閉じる
  overlay() {
    this.menuClose();
    this.overlayOff();
    this.htmlScroll();
  }

  //メニュー開く処理
  menuOpen(trigger, targetMenu) {
    trigger.addClass("is-open");
    $(".js-header-overlay").fadeIn();
    this.htmlFix();
    if ($(window).width() >= 768) {
      targetMenu.addClass("is-open").slideDown();
    } else {
      targetMenu.show().scrollTop(0).addClass("is-open");
      $(".js-header-menu-close").addClass("is-show");
      $(".js-header-menu-close").trigger("focus");
    }

    // header以外の要素をフォーカスから除外
    $(".wrapper").children().not("header").attr("inert", "true");

    // aria属性
    trigger.attr("aria-expanded", true);

    this.modalClickValues = trigger;
  }

  //メニュー閉じる処理
  menuClose() {
    $(".js-header-menu-trigger").removeClass("is-open");
    if ($(window).width() >= 768) {
      $(".js-header-menu")
        .removeClass("is-open")
        .slideUp(function () {
          $(this).removeAttr("style");
        });
    } else {
      $(".js-header-menu-close").removeClass("is-show");
      $(".js-header-menu")
        .stop()
        .removeClass("is-open")
        .delay(300)
        .queue(function () {
          $(this).hide().dequeue();
        });

      if (this.modalClickValues) {
        this.modalClickValues.trigger("focus");
      }
    }
    $(".wrapper").children().not("header").removeAttr("inert");

    // aria属性
    $(".js-header-menu-trigger").attr("aria-expanded", false);
  }

  //オーバーレイオフ
  overlayOff() {
    $(".js-header-overlay").fadeOut();
  }

  //スクロール禁止状態にする
  htmlFix() {
    var st = $(window).scrollTop() * -1;
    $("html").addClass("is-fixed");
    $("body").css("top", st);
  }

  //スクロール禁止状態を解除する
  htmlScroll() {
    var st = parseFloat($("body").css("top")) * -1;
    $("html").removeClass("is-fixed").scrollTop(st);
    $("body").removeAttr("style");
  }

  /** アニメーションせずにメニューを閉じる */
  #closeImmediately() {
    $(".js-header-menu-trigger").removeClass("is-open");
    if ($(window).width() >= 768) {
      $(".js-header-menu").removeClass("is-open").removeAttr("style");
    } else {
      $(".js-header-menu-close").removeClass("is-show");
      $(".js-header-menu").removeClass("is-open").hide();

      if (this.modalClickValues) {
        this.modalClickValues.trigger("focus");
      }
    }
    $(".wrapper").children().not("header").removeAttr("inert");

    // aria属性
    $(".js-header-menu-trigger").attr("aria-expanded", false);

    $(".js-header-overlay").hide();
    this.htmlScroll();
  }
}
